import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, delay, map, of, pipe, tap } from 'rxjs';
import { ApplicationUser } from '../models/ApplicationUser';
import { HttpClient } from '@angular/common/http';
import { User } from '../_models/user';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

interface LoginResult {
  UserId: string;
  Password: string;
  mobilenumber: string;
  UserOTP: string;
  AccessToken: string;
  RefreshToken: string; 
  RefreshTokenExpiretime: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  host: any;
  public currentUserSubject: any;
//  public currentUserSubject: BehaviorSubject<User> = new BehaviorSubject<User>();
  public currentUser: Observable<User> = new Observable<User>();
  public refreshtokentimer: Subscription | null = null;
  public starttokentimer: Subscription | null = null;

  public loggedUser : boolean = false;

  public _user = new BehaviorSubject<ApplicationUser | null>(null);
  user$ = this._user.asObservable();

  constructor(public http: HttpClient,public router : Router) {
    const data: any = sessionStorage.getItem('currentUser')
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(data));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    const data: any = sessionStorage.getItem('currentUser')
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(data));
    this.currentUser = this.currentUserSubject.asObservable();
    return this.currentUserSubject.value;
  }





  login(bodyobj : any) {
    const headers = { 'content-type': 'application/json' }
    return this.http.post<LoginResult>(environment.APIURL+ "login/" + sessionStorage.getItem('LoginType'), bodyobj, { 'headers': headers })
      .pipe(map((user: any) => {
        this._user.next({
          UserId: user.UserId,
          mobilenumber: user.mobilenumber,
          AccessToken: user.AccessToken,
          RefreshToken: user.RefreshToken,
        });
        console.log(JSON.stringify(user));

        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionStorage.setItem('currentUser', JSON.stringify(user));
        sessionStorage.setItem('access_token', user.AccessToken);
        sessionStorage.setItem('refresh_token', user.RefreshToken);
        sessionStorage.setItem('RefreshTokenExpiretime', user.RefreshTokenExpiretime);
        sessionStorage.setItem('login-event', 'login' + Math.random());
        this.setlocalStorage(user);
        return user;
      }
      ));
  }

  setlocalStorage(x: LoginResult) {
    sessionStorage.setItem('access_token', x.AccessToken);
    sessionStorage.setItem('refresh_token', x.RefreshToken);
    sessionStorage.setItem('RefreshTokenExpiretime', x.RefreshTokenExpiretime);
    sessionStorage.setItem('login-event', 'login' + Math.random());
  }

  
  refreshToken(): Observable<LoginResult | any> {
    const refreshToken = sessionStorage.getItem('refresh_token');

    if (!refreshToken) {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('RefreshTokenExpiretime');
      sessionStorage.setItem('logout-event', 'logout' + Math.random());
      this.currentUserSubject.next(null);
      return of(null);
    }

    return this.http.post<LoginResult>(environment.APIURL+"refresh-token", { refreshToken })
      .pipe(
        map((x) => {
          this._user.next({
            UserId: x.UserId,
            mobilenumber: x.mobilenumber,
            AccessToken: x.AccessToken,
            RefreshToken: x.RefreshToken
          });
          sessionStorage.setItem('currentUser', JSON.stringify(x));
          console.log(JSON.stringify(x));

          sessionStorage.setItem('access_token', x.AccessToken);
          sessionStorage.setItem('refresh_token', x.RefreshToken);
          sessionStorage.setItem('RefreshTokenExpiretime', x.RefreshTokenExpiretime);
          sessionStorage.setItem('login-event', 'login' + Math.random());
          this.refreshtokentimer?.unsubscribe();
          this.starttokentimer?.unsubscribe();
          this.RefreshTokenTimer();
          this.startTokenTimer();
          return x;
        })
      );
  }


  clearlocalStorage() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    sessionStorage.setItem('logout-event', 'logout' + Math.random());
    localStorage.removeItem('currentUser');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('RefreshTokenExpiretime');
    sessionStorage.setItem('logout-event', 'logout' + Math.random());
    this.currentUserSubject.next(null);
  }

  public stopTokenTimer() {
    this.starttokentimer?.unsubscribe();
    this.refreshtokentimer?.unsubscribe();
  }


  public startTokenTimer() {
    const timeout = this.getTokenRemainingTime('access_token');
    this.starttokentimer = of(true)
      .pipe(
        delay(timeout),
        tap({
          next: () => this.refreshToken().subscribe(),
        })
      )
      .subscribe();
  }


  public RefreshTokenTimer() {
    var tokentime = sessionStorage.getItem('RefreshTokenExpiretime')

    var current_timestamp = Math.floor(Date.now() / 1000);
    const expires = new Date(tokentime ? tokentime : current_timestamp * 1000);

    const timeout = expires.getTime() - Date.now();
    console.log(timeout)
    this.refreshtokentimer = of(true)
      .pipe(
        delay(timeout),
        tap({
          next: () => this.refreshToken().subscribe(),
        })
      )
      .subscribe();

    return of(null);
  }

  public getTokenRemainingTime(tokenname: any) {
    const accessToken = sessionStorage.getItem(tokenname);
    if (!accessToken) {
      return 0;
    }
    const jwtToken = JSON.parse(atob(accessToken.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    console.log(jwtToken.exp);
    return expires.getTime() - Date.now();
  }


  logout() {
    // remove user from local storage to log user out
    //sessionStorage.clear();

    this.currentUserSubject.next(null);

    
    var urltype = sessionStorage.getItem('LoginType');
    var logOut_URL = environment.LogoutURL + sessionStorage.getItem('LoginType');
    console.log('Logout', logOut_URL);
    //this.router.navigate([environment.LogoutURL])+ sessionStorage.getItem('LoginType');

    window.localStorage.removeItem("LogoutUser");
    sessionStorage.clear();
    localStorage.clear();

    sessionStorage.setItem("LoginType",urltype);
    this.router.navigateByUrl("login?type="+ sessionStorage.getItem('LoginType')).then(() => {
      window.location.reload();
    });;

    this.http.get(environment.APIURL+"logout").subscribe((data:any)=>{
    this.currentUserSubject.next(null);
    sessionStorage.setItem("LoginType",urltype);

    })




  }

}
